


































































































































































































import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { Severity } from '@sentry/types';

@Component
export default class PatientFileBodyInformations extends Vue {
  @Prop({ required: true }) private readonly patient!: TEntity<TPatient>;

  error: any = null;
  // Edit mode status
  editMode: any = {
    patientConsultation: false,
    patientBackground: false,
  };
  // Save loading
  loading: any = {
    patientConsultation: false,
    patientBackground: false,
  };
  // Current edit comment
  editComment: any = {
    patientConsultation: null,
    patientBackground: null,
  };

  async saveComment(type: string) {
    this.loading[type] = true;
    try {
      // Path for the $set option
      const path =
        type === 'patientBackground'
          ? { 'infos.background': this.editComment[type] }
          : { 'infos.consultationReason': this.editComment[type] };

      this.$pdc.repository?.patchRessource({
        ressource: 'patients',
        params: {
          _id: this.patient!._id,
        },
        data: {
          $set: path,
        },
      });
    } catch (e) {
      console.log(e);
      this.error = e;
      this.loading[type] = false;
    } finally {
      this.error = null;
      this.loading[type] = false;
    }
    this.loading[type] = false;
    // Quit the edit mode
    this.editMode[type] = false;
  }

  // Cancel the current comment
  cancelComment(type: string) {
    this.editMode[type] = false;
    this.loading[type] = false;
    this.error = null;
    if (type === 'patientBackground') {
      this.editComment[type] = this.patient.infos?.background ? this.patient.infos.background : '';
    }
    if (type === 'patientConsultation') {
      this.editComment[type] = this.patient.infos?.consultationReason ? this.patient.infos.consultationReason : '';
    }
  }
  getGender() {
    if (this.patient.infos.gender === 1) return 'M';
    return 'F';
  }
  breakLine(val: string) {
    return val.replace(/(\r\n|\n)/g, '<br/>');
  }

  mounted() {
    // Set current edit comment
    if (this.patient.infos.background) this.editComment.patientBackground = this.patient.infos.background;
    if (this.patient.infos.consultationReason)
      this.editComment.patientConsultation = this.patient.infos.consultationReason;
  }
}
